import { useMemo } from 'react'
import { V1OrderLineSearch } from 'next-gen-sdk'
import { Table, TableColumnType, TextHeader } from '@eltoro-ui/components'
import { usePagination } from '@eltoro-ui/hooks'
import { useAppContext } from 'Contexts'
import { EmptyField, TablePagination } from 'Components'
import { OrderlineStateIndicator } from 'Components/OrderlineTable/OrderlineStateIndicator'
import { orderLineStatusOptions } from 'searchOptions'
import { OrgNameCell } from '../../OrgNameCell'

// prettier-ignore
const searchOrderLineTableColumns = (isAdmin?: boolean): TableColumnType<V1OrderLineSearch>[] => [
  {
    path: 'name',
    label: 'Name',
    width: '22rem',
    removeFilter: true,
    removeSort: true,
  },
  {
    path: 'state',
    label: 'Status',
    filterOn: orderLineStatusOptions(isAdmin),
    removeFilter: true,
    removeSort: true,
    RowCell: ({ state }) =>
      state ? <OrderlineStateIndicator state={state} /> : <EmptyField />,
  },
  {
    path: 'orgId',
    label: 'Source Org',
    removeFilter: true,
    removeSort: true,
    RowCell: ({ orgLogo, orgName }) =>
      orgName ? <OrgNameCell name={orgName} logo={orgLogo} /> : <EmptyField />,
  },
  {
    path: 'orderLineId',
    label: 'ID',
    removeFilter: true,
    removeSort: true
  },
]

export const SearchOrderLineTable: React.FC<{
  results: V1OrderLineSearch[]
  handleRowClick: (clicked: V1OrderLineSearch) => void
}> = ({ results, handleRowClick }) => {
  const { isAdmin } = useAppContext()

  const orderLinePagination = usePagination<V1OrderLineSearch>({
    pageSize: 5,
    sourceData: results,
  })

  const tableColumns = useMemo(() => searchOrderLineTableColumns(isAdmin), [
    isAdmin,
  ])

  if (!results.length) return null

  return (
    <div className="SearchOrderLineTable">
      <TextHeader type={4} className="SearchOrderLineTable__header mt-4">
        Order Lines ({results.length})
      </TextHeader>
      {orderLinePagination.data && (
        <div className="p-4">
          <Table
            columns={tableColumns}
            rows={orderLinePagination.data}
            onClick={(ol) => handleRowClick(ol)}
          />
          <div className="flex justify-end pt-2">
            <TablePagination pagination={orderLinePagination} />
          </div>
        </div>
      )}
    </div>
  )
}
